import { defineMobileFormWindow } from "@app/overlay";
import {
    StockGatheringCompletionFilterForm,
    type StockGatheringCompletionFilterFormProps,
} from "./components/StockGatheringCompletionFilter/StockGatheringCompletionFilterForm";

/** Реестр overlay-окон списка КВ для комплектования. */
export const stockGatheringCompletionListWindows = {
    filter: defineMobileFormWindow<StockGatheringCompletionFilterFormProps>({
        key: "stock.gatheringCompletion.filter",
        title: "Фильтр КВ для комплектования",
        component: StockGatheringCompletionFilterForm,
    }),
};
